(() => {
  const FALLBACK_RATE = 89.87;
  const KEY = 'pkjp_nzd_jpy';
  const TTL = 12 * 60 * 60 * 1000;
  const fmt = new Intl.NumberFormat('ja-JP');
  let rate = null;

  const readCache = () => {
    try {
      const c = JSON.parse(localStorage.getItem(KEY));
      if (c && Date.now() - c.t < TTL) return c.r;
    } catch (e) {}
    return null;
  };

  const writeCache = (r) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ r, t: Date.now() }));
    } catch (e) {}
  };

  const DUTY_LIMIT_YEN = 16666;
  const DUTY_SHOW_FROM = 0.9;
  const FREE_SHIPPING_CENTS = 11000;
  const SHIPPING_CENTS = 3900;

  const paint = () => {
    if (!rate) return;
    document.querySelectorAll('.jpy-est[data-nzd-cents]').forEach((el) => {
      const yen = Math.round((Number(el.dataset.nzdCents) / 100) * rate);
      const text = `約 ¥${fmt.format(yen)}`;
      if (el.textContent !== text) el.textContent = text;
    });
    document.querySelectorAll('.jpy-duty[data-nzd-cents]').forEach((el) => {
      const cents = Number(el.dataset.nzdCents);
      const withShipping = cents + (cents < FREE_SHIPPING_CENTS ? SHIPPING_CENTS : 0);
      const yen = (withShipping / 100) * rate;
      el.hidden = yen < DUTY_LIMIT_YEN * DUTY_SHOW_FROM;
    });
  };

  const start = async () => {
    rate = readCache();
    if (!rate) {
      try {
        const res = await fetch('https://api.frankfurter.dev/v1/latest?from=NZD&to=JPY');
        const data = await res.json();
        rate = data.rates.JPY;
        writeCache(rate);
      } catch (e) {
        rate = FALLBACK_RATE;
      }
    }
    paint();
    new MutationObserver(paint).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
